import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { useState, type FC, ChangeEvent, useEffect } from "react";
import { DEFAULT_TXT_IMG_SIZE_ENUM } from "../../utils/constants";
import { SizeInputType, isStrNumErr } from "../../utils/number.util";

type Txt2ImgSizeModalProps = {
  open: boolean;
  onOkClick: (expSize: { width: number; height: number }) => void;
  onModalClose: (defaultSize: { width: number; height: number }) => void;
};

export const Txt2ImgSizeModal: FC<Txt2ImgSizeModalProps> = ({
  open,
  onOkClick,
  onModalClose,
}) => {
  const [size, setSize] = useState<SizeInputType>({
    width: DEFAULT_TXT_IMG_SIZE_ENUM.width,
    height: DEFAULT_TXT_IMG_SIZE_ENUM.height,
  });

  useEffect(() => {
    if (open) {
      setSize({
        width: DEFAULT_TXT_IMG_SIZE_ENUM.width,
        height: DEFAULT_TXT_IMG_SIZE_ENUM.height,
      });
    }
  }, [open]);

  return (
    <Modal open={open}>
      <Box
        id="txt-img-size-modal"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "16px",
          padding: "32px",
          background: "white",
          borderRadius: "5px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "16px",
            width: "100%",
          }}
        >
          <Typography variant="h6">文生图 - 设置生成图片尺寸</Typography>
          <TextField
            label="宽（像素）"
            value={size.width}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setSize({
                width: e.target.value,
                height: size.height,
              })
            }
            placeholder="256 ~ 4096"
            size="small"
            type="number"
            error={isStrNumErr(size.width)}
            helperText={isStrNumErr(size.width) ? "256 ~ 4096" : ""}
          />
          <TextField
            label="高（像素）"
            value={size.height}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setSize({
                width: size.width,
                height: e.target.value,
              })
            }
            placeholder="256 ~ 4096"
            size="small"
            type="number"
            error={isStrNumErr(size.height)}
            helperText={isStrNumErr(size.height) ? "256 ~ 4096" : ""}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "8px",
            width: "100%",
          }}
        >
          <Button
            size="small"
            variant="contained"
            onClick={() =>
              onOkClick({
                width:
                  typeof size.width === "string"
                    ? parseInt(size.width)
                    : size.width,
                height:
                  typeof size.height === "string"
                    ? parseInt(size.height)
                    : size.height,
              })
            }
            disabled={isStrNumErr(size.height) || isStrNumErr(size.width)}
          >
            确定
          </Button>
          <Button
            size="small"
            variant="outlined"
            onClick={() =>
              onModalClose({
                width: DEFAULT_TXT_IMG_SIZE_ENUM.width,
                height: DEFAULT_TXT_IMG_SIZE_ENUM.height,
              })
            }
          >
            取消
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
